import { HttpContext, HttpContextToken } from '@angular/common/http';

export const STORAGE_ID = new HttpContextToken<string>(() => '');

export const setStorageIdHttpContext = (storageId: string) => new HttpContext().set(STORAGE_ID, storageId);
